const {
    REACT_APP_CLIENT_ID,
    REACT_APP_API_KEY,
    REACT_APP_AUTH_SCOPE,
    REACT_APP_DRIVE_APP_ID
} = process.env;

export const initGDriveCall = async () => {
    try {
        await initClientLibrary();
        window.gapi.load('client:picker');
    } catch (err) {
        throw err;
    }
}


const initClientLibrary = () => {
    return new Promise((resolve, reject) => {
        window.gapi.load("client:auth2", () => {
            window.gapi.auth2.init({client_id: REACT_APP_CLIENT_ID})
                .then((res) => {
                    window.gapi.client.setApiKey(REACT_APP_API_KEY);
                    resolve(true)
                })
                .catch((err) => {
                    reject(err)
                });
        });
    })
}

export const googleSignin = (cb) => {
    window.gapi.auth2.getAuthInstance()
        .signIn({scope: REACT_APP_AUTH_SCOPE})
        .then(res => {
            cb(true)
        }, (err) => {
            cb(false)
        });
}

export const createPicker = (type, cb) => {
    const accessToken = window.gapi.auth.getToken().access_token;
    const view = new window.google.picker.View(window.google.picker.ViewId[type]);
    view.setMimeTypes([
        "application/vnd.google-apps.document",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/msword"
    ]);
    const picker = new window.google.picker.PickerBuilder()
        .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
        .setAppId(REACT_APP_DRIVE_APP_ID)
        .setOAuthToken(accessToken)
        .addView(view)
        .addView(new window.google.picker.DocsUploadView())
        .setDeveloperKey(REACT_APP_API_KEY)
        .setCallback((data) => {
            if (data.action === window.google.picker.Action.PICKED) {
                cb(data.docs[0])
            }
        })
        .build();
    picker.setVisible(true);
}